import { render, staticRenderFns } from "./PaymentStatusSubmittedInvoices.vue?vue&type=template&id=a3d51514&"
import script from "./PaymentStatusSubmittedInvoices.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusSubmittedInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports